import React from "react";

interface Props {
    onClick: () => void;
}

export default function BurgerButton({ onClick }: Props) {
    return (
        <button
            type="button"
            aria-label="Меню"
            onClick={onClick}
            className="flex flex-col justify-between w-8 h-5 md:w-10 md:h-6 lg:w-12 lg:h-7 focus:outline-none"
        >
            <span className="block w-full h-[2px] bg-primary-400"></span>
            <span className="block w-full h-[2px] bg-primary-400"></span>
            <span className="block w-full h-[2px] bg-primary-400"></span>
        </button>
    );
}
